
import { Component, Vue } from 'vue-property-decorator'
import RacingResultService from '@/biz/service/Racing/RacingResultService'
import RacingGroupService from '@/biz/service/Racing/RacingGroupService'
import RacingRoundService from '@/biz/service/Racing/RacingRoundService'
import { arrayChunk } from '@/service/ToolsService'
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import print from 'vue-print-nb'

@Component({
  directives: {
    print
  }
})
export default class ViewRacingPrintAbStart extends Vue {
  private RacingGroupService = RacingGroupService
  private RacingRoundService = RacingRoundService
  private list = [] as any[][]

  private handleLoad () {
    return RacingResultService.abIndex()
      .then((res) => {
        this.list = arrayChunk(res.data, 22)
      })
  }

  private handleTableLoad (index: number) {
    return Promise.resolve(this.list[index])
  }

  private handleSpanMethod ({ row, columnIndex } = {} as { row: any; column: any; rowIndex: number; columnIndex: number }) {
    if (columnIndex === 0) {
      if (row.merge > 0) {
        return {
          rowspan: row.merge,
          colspan: 1
        }
      } else {
        return {
          rowspan: 0,
          colspan: 0
        }
      }
    }
  }
}
